import { Box } from '@branch-messenger/willow-ui'
import { useMediaQuery } from '@uidotdev/usehooks'
import { FC } from 'react'

import { mediaQueries } from '@/styles/media'

import { MenuButton } from '../menu-button'
import { SidebarMenuProps } from './types'

export const SidebarMenuDesktop: FC<SidebarMenuProps> = ({ menuItems }) => {
  const isDesktop = useMediaQuery(mediaQueries.largeTabletAndUp)
  if (!isDesktop) return null
  return (
    <Box $display="flex" $direction="column" $align="initial" $gap={4}>
      {menuItems.map(menuItem => (
        <MenuButton key={menuItem.title} {...menuItem} />
      ))}
    </Box>
  )
}
